"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VirtualConnectionsDisplayGrid = void 0;
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var React = require("react");
var Localize_1 = require("../../../gen-src/Localize");
var globalTypes_1 = require("../../../gen-src/queries/globalTypes");
var LinkCellFormatter_1 = require("../datagrid/cellFormatters/LinkCellFormatter");
var ObfuscatedCellFormatter_1 = require("../datagrid/cellFormatters/ObfuscatedCellFormatter");
var UserNameCell_1 = require("../datagrid/cellFormatters/UserNameCell");
var shouldBeObfuscated = function (_a) {
    var name = _a.name;
    return name === null;
};
var projectContainerType = 'Project';
var rowDataFunctions = {
    getAssetUrlFromRowData: function (urls, _a) {
        var id = _a.id;
        return urls.virtualConnectionUrl(id);
    },
    getNameFromRowData: function (_a) {
        var name = _a.name;
        return name || '';
    },
    getTypeNameFromRowData: function () { return 'VirtualConnection'; },
    getDataQualityCertificationFromRowData: function (_a) {
        var dataQualityCertifications = _a.dataQualityCertifications;
        return dataQualityCertifications;
    }
};
function columns() {
    var cols = [
        function () { return ({
            name: 'certification',
            dataKey: '',
            headerText: '',
            headerTooltip: Localize_1.Messages.Certification(),
            headerFormatter: data_catalog_shared_1.DataQualityIconHeaderCertificationFormatterFactory,
            cellFormatter: data_catalog_shared_1.createDataQualityCellFormatter({
                getWarningsFromRowData: function (_a) {
                    var dataQualityWarnings = _a.dataQualityWarnings;
                    return dataQualityWarnings;
                },
                disableIconOnlyTabIndex: true,
                isCertification: true,
                rowDataFunctions: rowDataFunctions,
            }),
            sortable: false,
            resizable: false,
        }); },
        function () { return ({
            name: 'warning',
            dataKey: '',
            headerText: '',
            headerTooltip: Localize_1.Messages.DataQualityWarningTitle(),
            headerFormatter: data_catalog_shared_1.DataQualityIconHeaderFormatterFactory,
            cellFormatter: data_catalog_shared_1.createDataQualityCellFormatter({
                getWarningsFromRowData: function (_a) {
                    var dataQualityWarnings = _a.dataQualityWarnings;
                    return dataQualityWarnings;
                },
                disableIconOnlyTabIndex: true,
                isCertification: false,
                rowDataFunctions: rowDataFunctions,
            }),
            sortable: false,
            resizable: false,
        }); },
        function (sortParams) { return ({
            name: 'name',
            dataKey: globalTypes_1.VirtualConnectionOrderField.NAME,
            headerText: Localize_1.Messages.GridHeaderName(),
            headerFormatter: data_catalog_shared_1.createSortableHeaderFormatter(sortParams),
            cellFormatter: ObfuscatedCellFormatter_1.createObfuscatedLinkCellFormatter(shouldBeObfuscated, function (_a) {
                var name = _a.name;
                return name;
            }, function (urls, _a) {
                var vizportalUrlId = _a.vizportalUrlId;
                return urls.virtualConnectionLineagePath(vizportalUrlId);
            }),
            resizable: true,
            sortable: true,
        }); },
        function (sortParams) { return ({
            name: 'workbooks',
            dataKey: globalTypes_1.VirtualConnectionOrderField.DOWNSTREAM_WORKBOOKS_COUNT,
            headerText: Localize_1.Messages.GridHeaderWorkbooks(),
            headerFormatter: data_catalog_shared_1.createSortableHeaderFormatter(sortParams),
            cellFormatter: data_catalog_shared_1.createTextCellFormatter(function (_a) {
                var downstreamWorkbooksConnection = _a.downstreamWorkbooksConnection;
                return downstreamWorkbooksConnection
                    ? Localize_1.Formatters.formatCount(downstreamWorkbooksConnection.totalCount)
                    : null;
            }),
            resizable: true,
            sortable: true,
        }); },
        function (sortParams) { return ({
            name: 'datasources',
            dataKey: globalTypes_1.VirtualConnectionOrderField.DOWNSTREAM_DATASOURCES_COUNT,
            headerText: Localize_1.Messages.GridHeaderDatasources(),
            headerFormatter: data_catalog_shared_1.createSortableHeaderFormatter(sortParams),
            cellFormatter: data_catalog_shared_1.createTextCellFormatter(function (_a) {
                var downstreamDatasourcesConnection = _a.downstreamDatasourcesConnection;
                return downstreamDatasourcesConnection
                    ? Localize_1.Formatters.formatCount(downstreamDatasourcesConnection.totalCount)
                    : null;
            }),
            resizable: true,
            sortable: true,
        }); },
        function (sortParams) { return ({
            name: 'location',
            dataKey: globalTypes_1.VirtualConnectionOrderField.CONTAINER_NAME,
            headerText: Localize_1.Messages.GridHeaderLocation(),
            headerFormatter: data_catalog_shared_1.createSortableHeaderFormatter(sortParams),
            cellFormatter: LinkCellFormatter_1.createLinkOrTextCellFormatter(function (_a) {
                var containerType = _a.containerType, containerName = _a.containerName;
                return containerType === projectContainerType ? containerName : Localize_1.Messages.PersonalSpaceName();
            }, function (urls, _a) {
                var projectVizportalUrlId = _a.projectVizportalUrlId, containerType = _a.containerType;
                return (projectVizportalUrlId && containerType === projectContainerType ? urls.projectPath(projectVizportalUrlId) : null);
            }),
            resizable: true,
            sortable: true,
        }); },
        function (sortParams) { return ({
            name: 'owner',
            dataKey: data_catalog_shared_1.UnsortableColumnKey,
            headerText: Localize_1.Messages.GridHeaderOwner(),
            headerFormatter: data_catalog_shared_1.createSortableHeaderFormatter(sortParams),
            cellFormatter: UserNameCell_1.createUserNameLinkCellFormatter(function (_a) {
                var owner = _a.owner;
                return owner;
            }),
            resizable: true,
            sortable: false,
        }); },
    ];
    return cols.filter(Boolean);
}
function VirtualConnectionsDisplayGrid(props) {
    var cols = columns().map(function (columnFactory) { return columnFactory(props); });
    return (React.createElement(data_catalog_shared_1.ExplorerStyledDisplayGrid, { columns: cols, rowStore: props.rowStore, emptyGridMessage: props.emptyGridMessage, rowCount: props.rowCount, renderErrors: data_catalog_shared_1.reportGraphQLErrors, orderBy: props.orderBy, updateSortOrder: props.updateSortOrder }));
}
exports.VirtualConnectionsDisplayGrid = VirtualConnectionsDisplayGrid;
//# sourceMappingURL=VirtualConnectionsDisplayGrid.js.map